<div class="page-not-found">
  <div>
      <h1>404</h1>
      <p class="text">{{'PAGE_NOT_FOUND.TITLE'| translate}}</p>
      <p class="sub-text">{{'PAGE_NOT_FOUND.SUB_TITLE'| translate}}</p>
  </div>
</div>
